import { ChangeEvent } from 'react';
import { useContainer, useHttpAddCompanyLogo } from '../../hooks';
import { ToastStateHandler } from '../../api';
import { useSelector } from 'react-redux';
import { dispatch } from '../../store';
import { editOrganization, selectOrganization } from '../../store/slices/organization.slice';
import { LocalStorage } from '../../util/LocalStorage';
import { GlobalApi } from '../../util/Global';
import { useTranslation } from '../../hooks/useTranslation';

const MAX_FILE_SIZE_IN_BYTES = 2000000; //2MB

export const UploadImage = () => {
    const { t } = useTranslation('newNotifications');
    const storage: LocalStorage = useContainer(LocalStorage);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const globalApi: GlobalApi = useContainer(GlobalApi);
    const { exec } = useHttpAddCompanyLogo({ storage, toastHandler, globalApi });
    const organization = useSelector(selectOrganization);

    type UploadSuccessCallback = (data: string) => void;
    const uploadSuccess: UploadSuccessCallback = data => {
        dispatch(editOrganization({ logoUrl: `${data}?${organization.updatedAt}` }));
    };

    const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.currentTarget.files) return;
        const file = e.currentTarget.files[0];
        if (file.size >= MAX_FILE_SIZE_IN_BYTES) {
            toastHandler.push('error', t('organization.companyLogoUploadTitle'), t('organization.companyLogoUploadMessage_FailedImgSize'));
        } else if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
            toastHandler.push('error', t('organization.companyLogoUploadTitle'), t('organization.companyLogoUploadMessage_FailedImgType'));
        } else {
            await exec(file, { onSuccess: uploadSuccess });
        }
    };

    return (
        <div className="upload-image">
            {organization.logoUrl ? (
                <img src={organization.logoUrl} alt="" className="upload-image__img" />
            ) : (
                <img src="/img/upload-image-pictogram.svg" alt="" className="upload-image__img" />
            )}
            <div className="upload-image__upload">
                <div className="upload-image__label">Company Logo</div>
                <label htmlFor="upload-image">Upload image</label>
                <input type="file" name="image" id="upload-image" accept="image/png, image/jpg, image/jpeg, image/svg" onChange={handleFileChange} />
            </div>
        </div>
    );
};
